/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetSettingResponse
 */
export interface GetSettingResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetSettingResponse
     */
    settingId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetSettingResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GetSettingResponse
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof GetSettingResponse
     */
    group: string | null;
}

/**
 * Check if a given object implements the GetSettingResponse interface.
 */
export function instanceOfGetSettingResponse(value: object): value is GetSettingResponse {
    if (!('settingId' in value) || value['settingId'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    return true;
}

export function GetSettingResponseFromJSON(json: any): GetSettingResponse {
    return GetSettingResponseFromJSONTyped(json, false);
}

export function GetSettingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSettingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'settingId': ApiUserTasksGetPageParameterFromJSON(json['settingId']),
        'key': json['key'],
        'value': json['value'],
        'group': json['group'],
    };
}

export function GetSettingResponseToJSON(json: any): GetSettingResponse {
    return GetSettingResponseToJSONTyped(json, false);
}

export function GetSettingResponseToJSONTyped(value?: GetSettingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'settingId': ApiUserTasksGetPageParameterToJSON(value['settingId']),
        'key': value['key'],
        'value': value['value'],
        'group': value['group'],
    };
}

